import http from 'shared/utils/http';

export const getMonthlyPlanning = (filter) => {
  return http.get('/netwila-core/demand/planning', filter);
};

export const updateMonthlyPlanning = (data) => {
  return http.post('/netwila-core/demand/planning', data);
};
